const TRANSPARENT = /^(transparent|rgba\(0, 0, 0, 0\))$/;
const CHANNELS = /(\d+(?:\.\d+)?)/g;

function related(node: Element, chrome: Element): boolean {
  return node === chrome || node.contains(chrome) || chrome.contains(node);
}

export function surfaceColorAt(x: number, y: number, chrome?: Element | null): string | null {
  const stack =
    typeof document.elementsFromPoint === "function"
      ? document.elementsFromPoint(x, y)
      : [document.elementFromPoint(x, y)];
  for (const hit of stack) {
    if (!(hit instanceof HTMLElement) || (chrome && related(hit, chrome))) {
      continue;
    }
    for (let node: HTMLElement | null = hit; node; node = node.parentElement) {
      if (chrome && related(node, chrome)) {
        break;
      }
      const background = getComputedStyle(node).backgroundColor;
      if (!TRANSPARENT.test(background)) {
        return background;
      }
    }
  }
  return null;
}

export function isDark(colour: string): boolean {
  const parts = colour.match(CHANNELS)?.slice(0, 3).map(Number) ?? [];
  if (parts.length < 3) {
    return false;
  }
  const [red = 0, green = 0, blue = 0] = parts;
  return (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255 < 0.5;
}
